import * as BABYLON from 'babylonjs';

const FLOAT_EPSILON	= 1e-6;

export default class Utils2D {
/*****************************************************************************/
/**
    * Get distance for a point to a 2D Line
    * @param pt, point 
    * @param p1
    * @param p2, line ends
    */
static pointDistanceFromLine(pt, p1, p2) {
    const x = pt[0];
    const y = pt[1];
    const x1 = p1[0];
    const y1 = p1[1];
    const x2 = p2[0];
    const y2 = p2[1];

    let A = x - x1;
    let B = y - y1;
    let C = x2 - x1;
    let D = y2 - y1;

    let dot = A * C + B * D;
    let len_sq = C * C + D * D;
    let param = -1;
    if (len_sq != 0) //in case of 0 length line
        param = dot / len_sq;

    let xx, yy;

    if (param < 0) {
        xx = x1;
        yy = y1;
    }
    else if (param > 1) {
        xx = x2;
        yy = y2;
    }
    else {
        xx = x1 + param * C;
        yy = y1 + param * D;
    }

    let dx = x - xx;
    let dy = y - yy;
    return Math.sqrt(dx * dx + dy * dy);
}
/*****************************************************************************/
/**
    * Returns true if segment (p2, q2) lies fully inside (p1, q1)
    * @param p1, 
    * @param q1, line ends of first line
    * @param p2
    * @param p2, line ends of second line
    */
static isSegmentPartOfSegment(p1, q1, p2, q2, distanceThreshold = 0.0001) {
    return Utils2D.pointDistanceFromLine(p2, p1, q1) < distanceThreshold
        && Utils2D.pointDistanceFromLine(q2, p1, q1) < distanceThreshold;
}
/*****************************************************************************/
/**
* Get distance for a point to a 2D Line
* @param pt, point 
* @param p1
* @param p2, line ends
*/
static pointDistanceFromLineXY(pt, p1, p2) {
    const x = pt.x;
    const y = pt.y;
    const x1 = p1.x;
    const y1 = p1.y;
    const x2 = p2.x;
    const y2 = p2.y;

    let A = x - x1;
    let B = y - y1;
    let C = x2 - x1;
    let D = y2 - y1;

    let dot = A * C + B * D;
    let len_sq = C * C + D * D;
    let param = -1;
    if (len_sq != 0) //in case of 0 length line
        param = dot / len_sq;

    let xx, yy;

    if (param < 0) {
        xx = x1;
        yy = y1;
    }
    else if (param > 1) {
        xx = x2;
        yy = y2;
    }
    else {
        xx = x1 + param * C;
        yy = y1 + param * D;
    }

    let dx = x - xx;
    let dy = y - yy;
    return Math.sqrt(dx * dx + dy * dy);
}
/*****************************************************************************/
/**
    * Returns true if segment (p2, q2) lies fully inside (p1, q1)
    * @param p1, 
    * @param q1, line ends of first line
    * @param p2
    * @param p2, line ends of second line
    */
static isSegmentPartOfSegmentXY(p1, q1, p2, q2, distanceThreshold = 0.0001) {
    return Utils2D.pointDistanceFromLineXY(p2, p1, q1) < distanceThreshold
        && Utils2D.pointDistanceFromLineXY(q2, p1, q1) < distanceThreshold;
}
/*****************************************************************************/
static includePoint(vecPoint, vecMin, vecMax)
{
	if(vecPoint.x < vecMin.x)
		vecMin.x = vecPoint.x;
	if(vecPoint.y < vecMin.y)
		vecMin.y = vecPoint.y;

	if(vecPoint.x > vecMax.x)
		vecMax.x = vecPoint.x;
	if(vecPoint.y > vecMax.y)
		vecMax.y = vecPoint.y;
}
/*****************************************************************************/
static rayLineIntersection(pLine1Start, pLine1Dir, pLine2Start, pLine2End, fParallelTolerance = 0.00001, fEndTolerance = 0.00001)
{
    let pLine2Dir = pLine2End.subtract(pLine2Start);
    let fLine2Len = pLine2Dir.length();
    pLine2Dir.normalize();

    let intersect;
    let s,t;

    let pRes = {};
    pRes.dIntersect = Number.MAX_VALUE;
    pRes.dSecondLineLength = fLine2Len;
    pRes.dSecondLineIntersect = Number.MAX_VALUE;
    pRes.otherDir = null;

    if(Math.abs(Math.abs(BABYLON.Vector2.Dot(pLine1Dir, pLine2Dir)) - 1.0) < fParallelTolerance)
        return pRes;

    if(pLine2Dir.y == 0.0 && pLine2Dir.x == 0.0)
        return pRes;

    let numerator, denom;

    // For numerical stability, take the larger component
    if(pLine2Dir.y > pLine2Dir.x)
    {
        denom = pLine2Dir.x * pLine1Dir.y - pLine1Dir.x*pLine2Dir.y;
        if(denom == 0.0)
            return pRes;
        else
        {
            numerator = pLine2Dir.y*(pLine1Start.x - pLine2Start.x) - pLine2Dir.x*(pLine1Start.y - pLine2Start.y);

            // See if the intersect lies within the other line segment
            t = numerator/denom;
            intersect = pLine1Start.add(pLine1Dir.scale(t));
            s = BABYLON.Vector2.Dot(intersect.subtract(pLine2Start), pLine2Dir);
            if(s>-fEndTolerance && s<=fLine2Len+fEndTolerance)
            {
                pRes.dSecondLineIntersect = s;
                pRes.dIntersect = t;
                pRes.otherDir = pLine2Dir;
                return pRes;
            }
            else
                return pRes;
        }
    }
    else
    {
        denom = pLine2Dir.y*pLine1Dir.x - pLine1Dir.y*pLine2Dir.x;
        if(denom == 0.0)
            return pRes;
        else
        {
            numerator = pLine2Dir.x*(pLine1Start.y - pLine2Start.y) - pLine2Dir.y*(pLine1Start.x - pLine2Start.x);
            t = numerator/denom;
            intersect = pLine1Start.add(pLine1Dir.scale(t));
            s = BABYLON.Vector2.Dot(intersect.subtract(pLine2Start), pLine2Dir);

            if(s>-fEndTolerance && s<=fLine2Len+fEndTolerance)
            {
                pRes.dSecondLineIntersect = s;
                pRes.dIntersect = t;
                pRes.otherDir = pLine2Dir;
                return pRes;
            }
            else
                return pRes;
        }
    }
}
/*****************************************************************************/
static doSegmentsIntersect(vecStart1, vecEnd1, vecStart2, vecEnd2, fEndTolerance = 0.0)
{
    let pLine1Dir = vecEnd1.subtract(vecStart1);
    let fLine1Len = pLine1Dir.length();
    pLine1Dir.normalize();

    let pRes = Utils2D.rayLineIntersection(vecStart1, pLine1Dir, vecStart2, vecEnd2);

    if(pRes.dIntersect === Number.MAX_VALUE)
        return false;

    // Otherwise, see if the intersect distance is within our length
    return pRes.dIntersect - fEndTolerance >= 0.0 && pRes.dIntersect + fEndTolerance <= fLine1Len;
}
/*****************************************************************************/
static getAllRayPolygonIntersections(pRayStart, pRayDir, vecPoints)
{
    // Go through every side, check intersections.
    let pRayNorm = new BABYLON.Vector2(-pRayDir.y, pRayDir.x);

    let intersections = [];
    let intersectRes;
    let dIntersect, dSecondLineIntersect, dSecondLineLength;
    let dSign1, dSign2;

    let i, next_v, numVerts, additional_v;
    numVerts = vecPoints.length;

    for(i = 0;i < numVerts; i++)
    {
        next_v = (i + 1) % numVerts;

        intersectRes = Utils2D.rayLineIntersection(pRayStart, pRayDir, vecPoints[i], vecPoints[next_v], FLOAT_EPSILON);
        dIntersect = intersectRes.dIntersect;
        dSecondLineLength = intersectRes.dSecondLineLength;		

        if(dIntersect>=0.0 && dIntersect!=Number.MAX_VALUE)
        {
            // An intersection of some sort. Need to check if it doesn't happen exactly at
            // the vertex, and if it does, then decide what to do.
            if(dSecondLineIntersect<=FLOAT_EPSILON)
            {
                // Either this or the next if clause should be commented out so that the
                // case when the ray intersects a vertex exactly (and that vertex is in the middle
                // of a poly, so it's not just touching it) isn't counted twice.
            }
            else if(dSecondLineLength - dSecondLineIntersect<=FLOAT_EPSILON)
            {
                // close to vertex next_v
                additional_v = (next_v+1)%numVerts;

                // check i and next_v+1
                dSign1 = BABYLON.Vector2.Dot(vecPoints[i].subtract(pRayStart), pRayNorm);
                dSign2 = BABYLON.Vector2.Dot(vecPoints[additional_v].subtract(pRayStart),pRayNorm);

                if(dSign1*dSign2 <= 0)
                    intersections.push(intersectRes);
            }
            else
            {
                // just "normal" intersection
                intersections.push(intersectRes);
            }
        }
    }

    intersections.sort((info1, info2) => { return info1.dIntersect - info2.dIntersect; })
    return intersections;
}
/*****************************************************************************/
static isPointInPolygon(vecPoints, vecTestPoint)
{
    // let vecDir = new BABYLON.Vector2(-1, 0);
    // The reason we do this and not the simper thing above is because
    // we may end up having a vertex that is inside the polygon but matches
    // the y coordinate of one of the horizontal edges exactly; in that case,
    // we will get an incorrect count and decide that the point isn't in the polygon.
    // So we pick a ray that is unlikely to coincide with an edge exactly (especially
    // numerically). Of course, it is still theoretically possible. :)
    let vecDir = new BABYLON.Vector2(-1, -0.9);
    vecDir.normalize();
    let iCount = Utils2D.getAllRayPolygonIntersections(vecTestPoint, vecDir, vecPoints).length;
    return (iCount % 2) != 0;
}
/*****************************************************************************/
static doRectanglesIntersect(vecMinA, vecMaxA, vecMinB, vecMaxB)
{
    let aLeftOfB = vecMaxA.x < vecMinB.x;
    let aRightOfB = vecMinA.x > vecMaxB.x;
    let aAboveB = vecMinA.y > vecMaxB.y;
    let aBelowB = vecMaxA.y < vecMinB.y;

    return !(aLeftOfB || aRightOfB || aAboveB || aBelowB);
}
/*****************************************************************************/
static doesRectangleContainXZ(vecStart1, vecEnd1, vecStart2, vecEnd2)
{
	return (vecStart2.x >= vecStart1.x && vecEnd2.x <= vecEnd1.x
		&& vecStart2.z >= vecStart1.z && vecEnd2.z <= vecEnd1.z);
}
/*****************************************************************************/
static doRectanglesIntersectXZ(vecMinA, vecMaxA, vecMinB, vecMaxB)
{
    let aLeftOfB = vecMaxA.x < vecMinB.x;
    let aRightOfB = vecMinA.x > vecMaxB.x;
    let aAboveB = vecMinA.z > vecMaxB.z;
    let aBelowB = vecMaxA.z < vecMinB.z;

    return !(aLeftOfB || aRightOfB || aAboveB || aBelowB);
}
/*****************************************************************************/
static rotateArrayPoint(fX, fY, fDegrees)
{
    let fRads = fDegrees/180.0*Math.PI;
    let fSin = Math.sin(fRads);
    let fCos = Math.cos(fRads);

    let pRes = [];
    pRes[0] = fCos*fX - fSin*fY;
    pRes[1] = fSin*fX + fCos*fY;
    return pRes;
}
/*****************************************************************************/
static rotatePoint(pPoint, fDegrees, bForceVector3)
{
    let fRads = fDegrees/180.0*Math.PI;
    let fSin = Math.sin(fRads);
    let fCos = Math.cos(fRads);

    let pRes;
    if(bForceVector3)
        pRes = new BABYLON.Vector3(0, 0, 0);
    else
        pRes = new BABYLON.Vector2(0, 0);
    pRes.x = fCos*pPoint.x - fSin*pPoint.y;
    pRes.y = fSin*pPoint.x + fCos*pPoint.y;
    return pRes;
}
/*****************************************************************************/
static rotatePointToRef(pPoint, fDegrees, vecOut)
{
	const fRads = fDegrees/180.0*Math.PI;
	const fSin = Math.sin(fRads);
	const fCos = Math.cos(fRads);

	vecOut.x = fCos*pPoint.x - fSin*pPoint.y;
	vecOut.y = fSin*pPoint.x + fCos*pPoint.y;
}
/*****************************************************************************/
static computePointsBBox(pPoints)
{
    if(pPoints.length === 0)
        return { min: BABYLON.Vector2.Zero(), max: BABYLON.Vector2.Zero() };

    let vecMin = pPoints[0].clone();
    let vecMax = pPoints[0].clone();
    for(let idx = 1; idx < pPoints.length; idx++)
    {
        if(pPoints[idx].x < vecMin.x)
            vecMin.x = pPoints[idx].x;
        if(pPoints[idx].y < vecMin.y)
            vecMin.y = pPoints[idx].y;

        if(pPoints[idx].x > vecMax.x)
            vecMax.x = pPoints[idx].x;
        if(pPoints[idx].y > vecMax.y)
            vecMax.y = pPoints[idx].y;
    }

    return { 
        min: vecMin, max: vecMax,
        // TODO: We should really use these everywhere to match BJS, but for backwards
        // compat, the above are also included.
        minimumWorld: vecMin, maximumWorld: vecMax,
    };
}
/*****************************************************************************/
static doesIntersectRectangles(pCurrBBox, pAllBBoxes)
{
    for(let iBBox = 0; iBBox < pAllBBoxes.length; iBBox++)
    {
        if(Utils2D.doRectanglesIntersect(pCurrBBox.min, pCurrBBox.max, pAllBBoxes[iBBox].min, pAllBBoxes[iBBox].max))
            return true;
    }

    return false;
}
/*****************************************************************************/
static isPointInPoly(poly, pt)
{
    let c, i, l, j;
    for(c = false, i = -1, l = poly.length, j = l - 1; ++i < l; j = i)
        ((poly[i].y <= pt.y && pt.y < poly[j].y) || (poly[j].y <= pt.y && pt.y < poly[i].y))
        && (pt.x < (poly[j].x - poly[i].x) * (pt.y - poly[i].y) / (poly[j].y - poly[i].y) + poly[i].x)
        && (c = !c);
        // eslint-disable-next-line
    return c;
}
/*****************************************************************************/
static getAngleBetweenVectors(pVec1, pVec2)
{   
    return Math.atan2( (pVec1.x * pVec2.y - pVec1.y * pVec2.x), BABYLON.Vector2.Dot(pVec1, pVec2))/Math.PI*180.0;
}
/*****************************************************************************/
static getAngleFromPositiveX(fX, fY)
{
    let fAngle = Math.atan2(-fY, fX) / Math.PI * 180.0;
    if(fAngle < 0)
        fAngle += 360.0;
    return fAngle;
}
/*****************************************************************************/
static transformCanvasPositionToPDFSpace(position, pdfDoc, canvasSpaceSceneExtents)
{
    let canvasToPDFScale = pdfDoc._root.document.page.width / canvasSpaceSceneExtents.x;
    let scaledPos = position.scale(canvasToPDFScale);
    return scaledPos.add(new BABYLON.Vector3(0, pdfDoc._root.document.page.height * 0.25, 0));
}
/*****************************************************************************/
static getAbsPerpDistanceToLines(corners2D, vecPoint)
{
    let fMinDist = Number.MAX_VALUE;

    for(let idx = 0; idx < corners2D.length; idx++)
    {
        let vecStart = corners2D[idx];
        let vecEnd = corners2D[(idx + 1) % corners2D.length];

        let vecDir = vecEnd.subtract(vecStart);
        let fLength = vecDir.length();
        vecDir.normalize();
        let vecNorm = new BABYLON.Vector2(-vecDir.y, vecDir.x);

        let vecToStart = vecPoint.subtract(vecStart);

        let fProjDist = BABYLON.Vector2.Dot(vecToStart, vecDir);
        let fProjPerpDist = Math.abs(BABYLON.Vector2.Dot(vecToStart, vecNorm));
        if(fProjPerpDist < fMinDist && fProjDist >= 0 && fProjDist <= fLength)
            fMinDist = fProjPerpDist;

        if(vecToStart.length() < fMinDist)
            fMinDist = Math.abs(vecToStart.length());

        let vecToEnd = vecPoint.subtract(vecEnd);
        if(vecToEnd.length() < fMinDist)
            fMinDist = Math.abs(vecToEnd.length());
    }

    return fMinDist;
}
/*****************************************************************************/
/**
    * Calculates and returns the area of the 2d polygon
    * @param shape2D, number[][]
    * returns number: area of the polygon
    */
static calculatePolygonArea(shape2D) {
    let total = 0;

    for (let i = 0, l = shape2D.length; i < l; i++) {
        let addX = shape2D[i][0];
        let addY = shape2D[i == shape2D.length - 1 ? 0 : i + 1][1];
        let subX = shape2D[i == shape2D.length - 1 ? 0 : i + 1][0];
        let subY = shape2D[i][1];

        total += (addX * addY * 0.5);
        total -= (subX * subY * 0.5);
    }

    return Math.abs(total);
}
/*****************************************************************************/
static calculatePolygonAreaXY(points) {
    let area = 0.0;
    let p0, p1;
    for(let i = 0; i < points.length; i++)
    {
    	p0 = points[i];
    	p1 = points[(i + 1) % points.length];
    	area += (p0.x*p1.y) - (p1.x*p0.y);
    }
    return Math.abs(area*0.5);
}
/*****************************************************************************/
static getPolyCentroid(points)
{
    let xsum = 0.0;
    let ysum = 0.0;
    let area = 0.0;

    let p0, p1;
    let areaSum;
    for(let i = 0; i < points.length - 1; i++)
    {
		p0 = points[i];
		p1 = points[i +1];

		areaSum = (p0.x*p1.y) - (p1.x*p0.y);

		xsum += (p0.x + p1.x)*areaSum;
		ysum += (p0.y + p1.y)*areaSum;
		area += areaSum;
    }

	area *= 0.5;

	return new BABYLON.Vector2(xsum/(area*6), ysum/(area*6));
}
/*****************************************************************************/
static isPointInBBox(vecPoint, vecMin, vecMax)
{
	return vecPoint.x >= vecMin.x && vecPoint.x <= vecMax.x
			&& vecPoint.y >= vecMin.y && vecPoint.y <= vecMax.y;
}
/*****************************************************************************/
static isValidPolygon(vecPoints, bTestLastSegment = true)
{
	if(vecPoints.length < 3)
		return false;

	// Check that no segment intersects another segment
	let iOffset = bTestLastSegment ? 0 : -1;
	for(let idx = 0; idx < vecPoints.length + iOffset; idx++)
	{
		let iNextIdx = (idx + 1)%vecPoints.length;
		for(let idx2 = 0; idx2 < vecPoints.length + iOffset; idx2++)
		{
			if(idx2 === idx)
				continue;

			let iNextIdx2 = (idx2 + 1)%vecPoints.length;
			if(Utils2D.doSegmentsIntersect(vecPoints[idx], vecPoints[iNextIdx], vecPoints[idx2], vecPoints[iNextIdx2], 1e-4))
				return false;
		}
	}

	return true;
}
/*****************************************************************************/
static calculateSignedPolygonAreaXY(points) 
{
	let area = 0.0;
	let p0, p1;
	for(let i = 0; i < points.length; i++)
	{
    	p0 = points[i];
    	p1 = points[(i + 1) % points.length];
    	area += (p0.x*p1.y) - (p1.x*p0.y);
	}
	return area*0.5;
}
/*****************************************************************************/
static areSegmentsIdentical(vecStart1, vecEnd1, vecStart2, vecEnd2, distanceThreshold = FLOAT_EPSILON)
{
    let tempVec = BABYLON.Vector2.Zero();

    vecStart1.subtractToRef(vecStart2, tempVec);
    let fDist1a = tempVec.lengthSquared();
    vecEnd1.subtractToRef(vecEnd2, tempVec);
    let fDist2a = tempVec.lengthSquared();

    vecStart1.subtractToRef(vecEnd2, tempVec);
    let fDist1b = tempVec.lengthSquared();
    vecEnd1.subtractToRef(vecStart2, tempVec);
    let fDist2b = tempVec.lengthSquared();

    const thresholdSquared = distanceThreshold*distanceThreshold;
    return (fDist1a < thresholdSquared && fDist2a < thresholdSquared) || (fDist1b < thresholdSquared && fDist2b < thresholdSquared);
}
/*****************************************************************************/
static doSegmentsIntersectFast(vecStart1, vecEnd1, vecStart2, vecEnd2, epsilon = 0.0)
{
    let det, gamma, lambda;
    det = (vecEnd1.x - vecStart1.x)*(vecEnd2.y - vecStart2.y) - (vecEnd2.x - vecStart2.x)*(vecEnd1.y - vecStart1.y);
    if(Math.abs(det) < epsilon)
        return false;

    lambda = ((vecEnd2.y - vecStart2.y) * (vecEnd2.x - vecStart1.x) + (vecStart2.x - vecEnd2.x) * (vecEnd2.y - vecStart1.y)) / det;
    gamma = ((vecStart1.y - vecEnd1.y) * (vecEnd2.x - vecStart1.x) + (vecEnd1.x - vecStart1.x) * (vecEnd2.y - vecStart1.y)) / det;
    return (epsilon < lambda && lambda < 1 - epsilon) && (epsilon < gamma && gamma < 1 - epsilon);
}
/*****************************************************************************/
static doesContainPolygon(outerPoly, innerPoly, distanceThreshold = 0.0001)
{
	for(let index = 0; index < innerPoly.length; index++)
    {
        // See if the point is directly on the edge:
        let bIsOnEdge = false;
        for(let outerIdx = 0; outerIdx < outerPoly.length; outerIdx++)
        {
            const nextOuterIndex = (outerIdx + 1)%outerPoly.length;
            if(Utils2D.pointDistanceFromLineXY(innerPoly[index], outerPoly[outerIdx], outerPoly[nextOuterIndex]) < distanceThreshold)
            {
                bIsOnEdge = true;
                break;
            }
        }
        if(bIsOnEdge)
            continue;
        
        if(!Utils2D.isPointInPoly(outerPoly, innerPoly[index]))
            return false;
    }  

	for(let index = 0; index < innerPoly.length; index++)
    {
        const nextIndex = (index + 1)%innerPoly.length;
        if(Utils2D.doesIntersectPolygon(innerPoly[index], innerPoly[nextIndex], outerPoly, true, 1e-4)) {
            Utils2D.doesIntersectPolygon(innerPoly[index], innerPoly[nextIndex], outerPoly, true, 1e-4);
            return false;
        }
    }

    return true;
}
/*****************************************************************************/
static doesIntersectPolygon(vecStart, vecEnd, vecPoints, bTestLastSegment = true, epsilon = 0.0)
{
    // Check that no segment intersects another segment
    let iOffset = bTestLastSegment ? 0 : -1;
    for(let idx = 0; idx < vecPoints.length + iOffset; idx++)
	{
        let iNextIdx = (idx + 1)%vecPoints.length;
        if(Utils2D.doSegmentsIntersectFast(vecStart, vecEnd, vecPoints[idx], vecPoints[iNextIdx], epsilon))
            return true;
	}

    return false;
}
/*****************************************************************************/
static isPointOnSegment(vecPoint, vecStart, vecEnd, optEpsilon = FLOAT_EPSILON)
{
    if(Utils2D.perpDistanceFromLine(vecPoint, vecStart, vecEnd) > optEpsilon)
        return false;

    // Otherwise, see if it's within us length-wise:
    let vecToOrigin = vecPoint.subtract(vecStart);
    let vecDir = vecEnd.subtract(vecStart);
    let fLength = vecDir.length();
    vecDir.normalize();

    let fDist = BABYLON.Vector2.Dot(vecToOrigin, vecDir);
    if(fDist < -optEpsilon || fDist > fLength + optEpsilon)
        return false;

    return true;
}
/*****************************************************************************/
static perpDistanceFromLine(vecPoint, vecStart, vecEnd)
{
    let vecToOrigin = vecPoint.subtract(vecStart);
    let vecNorm = vecEnd.subtract(vecStart);
    vecNorm.normalize();
    vecNorm.set(vecNorm.y, -vecNorm.x);

    return Math.abs(BABYLON.Vector2.Dot(vecNorm, vecToOrigin));
}
/*****************************************************************************/
static getClosestPoint(vecPoint, vecStart, vecEnd)
{
    let vecToOrigin = vecPoint.subtract(vecStart);
    let vecDir = vecEnd.subtract(vecStart);
    let fLen = vecDir.length();
    vecDir.normalize();

    let fDist = BABYLON.Vector2.Dot(vecDir, vecToOrigin);
    if(fDist < 0)
        fDist = 0;
    else if(fDist > fLen)
        fDist = fLen;

    vecDir.scaleInPlace(fDist);
    return vecStart.add(vecDir);
}
/*****************************************************************************/
static getElementRectWithChildren(startElement)
{
	let ownRect = startElement.getBoundingClientRect();

    let resBBox;
    if(ownRect.width > 0)
        resBBox = { 
            min: new BABYLON.Vector2(ownRect.x, ownRect.y),
            max: new BABYLON.Vector2(ownRect.x + ownRect.width, ownRect.y + ownRect.height),
        };
    else
        resBBox = { 
            min: new BABYLON.Vector2(Number.MAX_VALUE, Number.MAX_VALUE),
            max: new BABYLON.Vector2(-Number.MAX_VALUE, -Number.MAX_VALUE),
        };

    for(let child of startElement.children)
	{
        let bbox = Utils2D.getElementRectWithChildren(child);
        if(bbox.min.x === Number.MAX_VALUE)
            continue;

        Utils2D.includePoint(bbox.min, resBBox.min, resBBox.max);
        Utils2D.includePoint(bbox.max, resBBox.min, resBBox.max);
	}

    return resBBox;
}
/*****************************************************************************/
static doBBoxesIntersect(vecMinA, vecMaxA, vecMinB, vecMaxB)
{
    let aLeftOfB = vecMaxA.x < vecMinB.x;
    let aRightOfB = vecMinA.x > vecMaxB.x;
    let aAboveB = vecMinA.y > vecMaxB.y;
    let aBelowB = vecMaxA.y < vecMinB.y;

    return !(aLeftOfB || aRightOfB || aAboveB || aBelowB);
}
/*****************************************************************************/
};